import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import styles from './styles.module.scss';
import { useAppDispatch, useAppSelector } from '@/_store/hooks';
import useScreenType from '@/hooks/util/useScreenType';
import { UserName } from './components/user-name';
import { MenuCategory } from './components/menu-category';
import { LogoutButton } from './components/logout-button';
import { QueroLogLogo } from './components/quero-logo';
import { useNavbarMenus } from '@/_hooks/use-nav-bar-menu';
import { selectUser } from '@/_store/modules/auth/selectors';
import { setMenuOpened } from '@/_store/modules/layout';
import { selectMenuOpened } from '@/_store/modules/layout/selectors';
import { useActivatedMenuListener } from '@/_hooks/use-activated-menu-listener';

function NavBar() {
  const dispatch = useAppDispatch();

  const isMobile = useScreenType('mobile');
  const { menus } = useNavbarMenus();

  useActivatedMenuListener();

  const menuOpened = useAppSelector(selectMenuOpened);
  const user = useAppSelector(selectUser);

  return (
    <>
      <div
        className={`${styles.navBar} ${menuOpened ? styles.opened : ''}`}
        data-opened={menuOpened}
        role="menubar"
      >
        {isMobile && menuOpened && (
          <div className={styles.closedMenuMobile}>
            <div
              className={styles.icon}
              onClick={() => dispatch(setMenuOpened(!menuOpened))}
            >
              <FontAwesomeIcon icon={faTimes} color="white" size="lg" />
            </div>
          </div>
        )}

        <QueroLogLogo />

        <UserName name={user?.nome || ''} />

        {menus.map(category => {
          if (!category) {
            return null;
          }
          return <MenuCategory key={category.key} category={category} />;
        })}

        <LogoutButton />
      </div>
    </>
  );
}

export { NavBar };
